import { render, staticRenderFns } from "./SaveSettingsDialog.vue?vue&type=template&id=2e817250&scoped=true&"
import script from "./SaveSettingsDialog.vue?vue&type=script&lang=ts&"
export * from "./SaveSettingsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e817250",
  null
  
)

export default component.exports